module.exports = __webpack_public_path__ + "img/img9.c5768354.svg";